import {
  Card,
  CardCaption,
  CardTitle,
  EducationScreen,
  Gold,
  RevealBlock,
  ScreenBody,
  ScreenIntro,
  ScreenSubhead,
} from './EducationShell';
import {FamilyTreeViz, MechanismChainViz, type FamilyTreeItem} from './Step9Viz';

const ITEMS: FamilyTreeItem[] = [
  {name: 'Weekly injection', indication: 'Chronic weight management, Type 2 diabetes', iconKind: 'syringe'},
  {name: 'Nightly drops', indication: 'Sleep apnea', iconKind: 'drops'},
];

/** Step 9 — compounded. Simplified 2-item comparison (Weekly injection vs
 *  Nightly drops); drops are highlighted. Mechanism chain + weight-loss
 *  closing copy. No pharmacy row in this rev of the Figma. */
export const Glp1EducationFamilyCompounded = () => (
  <EducationScreen
    ctaLabel="Next"
    variant="compounded_v1"
    analyticsShown="GLP-1 Funnel Education Family Viewed"
    analyticsSubmitted="GLP-1 Funnel Education Family Continue Tapped"
  >
    <ScreenIntro
      headline={
        <>
          Real progress, <Gold>one drop</Gold> at a time.
        </>
      }
      subhead="A mint-flavored compounded semaglutide drop under your tongue. Dissolves in 30 seconds. Personalized by your clinician for your airway response."
    />

    <RevealBlock delayMs={300}>
      <Card>
        <CardTitle>
          <Gold>Custom clinician-led dosing</Gold> for sleep apnea.
        </CardTitle>
        <FamilyTreeViz items={ITEMS} highlightedIdx={1} delayMs={200} />
        <CardCaption>
          A compounded semaglutide dosed specifically for sleep apnea. Delivered as nightly drops (under-the-tongue,
          mint-flavored, dissolves in 30–60 seconds). Personalized dosing by your clinician for airway response and side
          effect mitigation.
        </CardCaption>
      </Card>
    </RevealBlock>

    <RevealBlock delayMs={300}>
      <Card>
        <CardTitle>
          Less pressure on your airway. <Gold>Fewer collapses</Gold>
        </CardTitle>
        <MechanismChainViz delayMs={200} />
        <CardCaption>
          Most weight-loss GLP-1s push toward maximum dose on a fixed schedule. We do the opposite: your clinician
          starts gently, titrates based on how your airway responds, and stops once it&apos;s open — often well before
          max dose. Lower dose, fewer side effects, focused on the airway.
        </CardCaption>
      </Card>
    </RevealBlock>

    <RevealBlock delayMs={500}>
      <ScreenSubhead>About the weight loss.</ScreenSubhead>
      <ScreenBody>
        Most people lose weight along the way — that&apos;s part of how compounded semaglutides work. But your clinician
        titrates to airway response, not weight loss, so you often stay at lower doses than weight-loss protocols.
        GLP-1s may bring other benefits: better cardiovascular health, more stable blood sugar, less inflammation.
      </ScreenBody>
    </RevealBlock>
  </EducationScreen>
);

export default Glp1EducationFamilyCompounded;
